function gtag() { 
    if (window.dataLayer) {
        window.dataLayer.push(arguments);
    }  
}

export function applyEventCallback(callback) {
    try {
        gtag('event', 'optimize.callback', {
            callback: callback
        });
    } catch (err) {
        console.error(err);
    }
}